export default __webpack_public_path__ + "static/media/icon-swap.d8c84406.svg";